// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"436":"b21d47d6","453":"4becf13b","455":"b78e5b1f","977":"a09f6c2b"}[chunkId] + ".chunk.js";
};